import { createAction } from '@ngrx/store';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';

import { httpError, payload } from 'ish-core/utils/ngrx-creators';

import { DotCmsNavigationDepth } from '../../services/dot-cms-resource/dot-cms-resource.service';

export const loadDotCmsHeaderNavigation = createAction(
  '[DotCMS Nav Internal] load dotCMS header navigation',
  payload<{
    depth?: DotCmsNavigationDepth;
  }>()
);

export const loadDotCmsHeaderNavigationSuccess = createAction(
  '[DotCMS Nav API] load dotCMS header navigation success',
  payload<{
    navigationItem?: DotCMSNavigationItem;
  }>()
);

export const loadDotCmsHeaderNavigationFail = createAction(
  '[DotCMS Nav API] load dotCMS header navigation fail',
  httpError()
);

export const updateUVENavigation = createAction(
  '[Dotcms UVE Editor] Update Navigation UVE Editor',
  payload<{ pathname: string }>()
);

export const triggerDotcmsLoading = createAction('[Dotcms Navigation loading]');
